import { DocumentsAISummaryMutationType } from './mutation_type'
import { DocumentsAISummaryState } from './state'

export const mutations: StoreMutations<DocumentsAISummaryMutationType, DocumentsAISummaryState> = {
  SET_DOCUMENT_TO_SUMMARIZE_WITH_AI (state, document) {
    state.documentToSummarize = document
  },
  SET_REQUEST_SUMMARY_PENDING (state, pending) {
    state.requestSummaryPending = pending
  },
  SET_SUMMARIES_CREDITS (state, summariesCredits) {
    state.summariesCredits = summariesCredits
  },
  SET_SUMMARIES_CREDITS_PENDING (state, pending) {
    state.summariesCreditsPending = pending
  },
}
